import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

// =====================
// REQUEST INTERCEPTOR
// =====================
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // attach token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // ✅ IMPORTANT FIX: DO NOT DELETE CONTENT-TYPE
    // Let browser set it automatically for FormData
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// =====================
// RESPONSE INTERCEPTOR
// =====================
axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    console.error("API ERROR:", {
      data: error?.response?.data,
      status: error?.response?.status,
      message: error.message,
    });

    return Promise.reject(error);
  }
);

export default axiosInstance;